// import React from "react";
import React, { useEffect, useRef } from "react";

import * as actions from './Actions';
import Service from '../service/Service';
const service = new Service();

export default function MemoryComment({ eleRef }) {
    // //console.log("eleRef ---- ",eleRef)
  const popupRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      const popupOverlay = document.querySelector(
        ".addPost-overlay.addReply-overlay.feedComment"
      );
      if (!popupOverlay) return;

      const isVisible = window.getComputedStyle(popupOverlay).display !== "none";
      if (!isVisible) return; // only work when popup is open

      const popup = popupRef.current;
      if (!popup) return;

      // ESC closes popup
      if (e.key === "Escape" || e.key === "Esc") {
        console.log("Escape key pressed");
        e.preventDefault();
        actions.closePopupcommon2();
        const prevFocusable1 = document.querySelector('[data-popup="memory' + eleRef.state.postMemoryId + '"]');
        console.log("prevFocusable1 ",prevFocusable1);
        if (prevFocusable1) prevFocusable1.focus();
        return;
      }

      // TAB: keep focus inside popup
      if (e.key === "Tab") {
        const focusableSelectors = `
          a[href], area[href], input:not([disabled]),
          select:not([disabled]), textarea:not([disabled]),
          button:not([disabled]), [tabindex]:not([tabindex="-1"])
        `;

        const focusableElements = Array.from(
          popup.querySelectorAll(focusableSelectors)
        ).filter((el) => el.offsetParent !== null); // visible elements only

        if (focusableElements.length === 0) return;

        const firstEl = focusableElements[0];
        const lastEl = focusableElements[focusableElements.length - 1];
        const activeEl = document.activeElement;

        // If Shift+Tab from first element → go to last
        if (e.shiftKey) {
          if (activeEl === firstEl || !popup.contains(activeEl)) {
            e.preventDefault();
            lastEl.focus();
          }
        } else {
          // Tab from last element → go to first
          if (activeEl === lastEl || !popup.contains(activeEl)) {
            e.preventDefault();
            firstEl.focus();
          }
        }
      }
    };

    // Attach global listener
    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  // Ensure popup gets focus when opened
  // useEffect(() => {
  //   const popupOverlay = document.querySelector(
  //     ".addPost-overlay.addReply-overlay.feedComment"
  //   );
  //   if (!popupOverlay) return;

  //   const observer = new MutationObserver(() => {
  //     const isVisible = window.getComputedStyle(popupOverlay).display !== "none";
  //     if (isVisible && popupRef.current) {
  //       // Focus first visible focusable element
  //       const focusable = popupRef.current.querySelector(
  //         `textarea, input, [tabindex]:not([tabindex="-1"])`
  //       );
  //       if (focusable) focusable.focus();
  //     }
  //   });

  //   observer.observe(popupOverlay, { attributes: true, attributeFilter: ["style"] });
  //   return () => observer.disconnect();
  // }, []);
  

    return (
        <div className="addPost-overlay addReply-overlay feedComment">
            <div className="addPost-popup" role="dialog" ref={popupRef} aria-modal="true">
             <input type="hidden" value={eleRef.state.postMemoryId} id="memoryIdval" />
                <div className="addPost-header">
                    <span className="icon" data-icon-font="s" onClick={() => actions.closePopupcommon2()} role="button" tabIndex={0} aria-label="Go Back"  onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " " || e.key === "Escape") {
                                e.preventDefault();
                                actions.closePopupcommon2();
                                // Move focus back on Enter/Space/Esc
                                const prevFocusable1 = document.querySelector('[data-popup="memory' + eleRef.state.postMemoryId + '"]');
                                if (prevFocusable1) prevFocusable1.focus();
                            }
                        }}></span>
                    <span className="M18_white" role="heading" tabIndex={0} aria-label={eleRef.state.commentType == "reply" ? "Add a Reply" : "Add a Comment"}>{eleRef.state.commentType == "reply" ? "Add a Reply" : "Add a Comment"}</span>
                </div>
                {eleRef.state.prevComments && eleRef.state.prevComments.length > 0 &&
                    <div className="prev_cmt">
                        <ul>
                            {eleRef.state.prevComments.map((prev, pi) =>
                                <li key={pi}>
                                    <span className="M14_42">{prev.userName}</span>
                                    <span className="R14_42">{eleRef.state.commentType == "reply" ? prev.reply : prev.comment}</span>
                                </li>
                            )}
                        </ul>
                    </div>
                }
                <div className="addPost-wrap">
                    <textarea placeholder={eleRef.state.commentType == "reply" ? "Write Your Reply Here" : "Write Your Comment Here"} id="postcomment" name="postcomment" tabIndex={0} aria-label={eleRef.state.commentType == "reply" ? "Write Your Reply Here" : "Write Your Comment Here"}></textarea>
                    <div className="memory-cmt-err"></div>
                    <div className="addPost-btn M14_white" onClick={() => actions.addPost(eleRef)} role="button" tabIndex={0} aria-label={eleRef.state.commentType == "reply" ? "Post Your Reply" : "Post Your Comment"} onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault(); // prevent scrolling when pressing Space
                            actions.addPost(eleRef);
                        }
                    }}>
                        <span>POST</span>
                        <span className="icon" data-icon-font=""></span>
                    </div>
                </div>
            </div>
        </div>
    );
}
